import css from '../../../utils/css';

export default css`
  :host {
    --color-1: white;
    --color-2: #20242e;
    --color-3: #1ed560;
    --color-4: #052643;

    /* Adapter */
    --widget-background-color: var(--color-1);
    --widget-text-color: var(--color-2);
    --widget-subtext-color: #9d9da3;
    --widget-border-color: #9dafbd;
    --widget-divider-color: #f2f2f2;

    --widget-header-bg-color: var(--color-4);
    --widget-header-text-color: var(--color-1);
    --widget-header-odds-bg-color: #eaeae9;
    --widget-header-odds-shadow: #ccc;

    --widget-mobile-seeall-color: var(--color-3);

    --widget-grid-best-odds-bg-color: var(--color-4);
    --widget-grid-best-odds-border-color: var(--color-4);
    --widget-grid-best-odds-text-color: var(--color-3);

    --widget-grid-compare-active-bg-color: var(--color-3);
    --widget-grid-compare-color: var(--color-4);

    --widget-grid-ribbon-bg-color: var(--color-3);
    --widget-grid-ribbon-color: var(--color-1);
  }
`;
